import {
    Box,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    Text,
    FormHelperText,
    Link,
    Flex,
    Tooltip,
} from '@chakra-ui/react';
import { InformationIcon } from '@assets/icons/index';

export const CoordinateComp = ({ label, values, onChange }) => {
    return (
        <FormControl>
            <Flex justifyContent="space-between" alignItems="center">
                <FormLabel as={Text} fontSize="14px" fontWeight={700}>
                    {label}
                </FormLabel>
                <Tooltip
                    hasArrow
                    label="Untuk memastikan akurasi lokasi toko menggunakan koordinat latitude & longitude"
                    textAlign="center"
                >
                    <Box cursor={'pointer'}>
                        <InformationIcon />
                    </Box>
                </Tooltip>
            </Flex>

            <InputGroup gap="12px">
                <Input
                    value={values?.latitude}
                    placeholder="Latitude ..."
                    onChange={(e) => onChange({ latitude: e.target.value })}
                />
                <Input
                    value={values?.longitude}
                    placeholder="Longitude ..."
                    onChange={(e) => onChange({ longitude: e.target.value })}
                />
            </InputGroup>

            <FormHelperText>
                Temukan panduan mengisi koordinat{' '}
                <Link
                    color="info.500"
                    href="https://support.google.com/maps/answer/18539?hl=en&co=GENIE.Platform%3DDesktop"
                    target="_blank"
                    sx={{ textDecoration: 'underline' }}
                >
                    disini
                </Link>
            </FormHelperText>
        </FormControl>
    );
};
